import React from 'react'
import MissionVision from '../home/MissionVision'
import OurTeam from '../home/OurTeam'
import HomeReviews from '../home/HomeReviews'
import HomeGallery from '../home/HomeGallery'
import HomeBlog from '../home/HomeBlog'
import { Link } from "react-router-dom";
import HomeAbout from '../home/HomeAbout'
import Opportunities from '../home/Opportunities'


const AboutUs = () => {
  return (
    <>

      <div className="site-breadcrumb" style={{ background: 'url(assets/school/about.webp)' }}>
        <div className="container">
          <h2 className="breadcrumb-title">About Us</h2>
          <ul className="breadcrumb-menu">
            <li><Link to="/">Home</Link></li>
            <li className="active" style={{ color: "red" }}>About Us</li>
          </ul>
        </div>
      </div>

      <HomeAbout />
      <MissionVision />
      <Opportunities />  {/* Why Choose Us */}
      <HomeGallery />



    </>
  )
}

export default AboutUs